import React from 'react';
import { Link } from 'react-router-dom';

const ImageCurtain = () => {
  return (
    <section className="image-curtain-section">
      <div className="curtain-container">
        <div
          className="curtain-image"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1541829070764-84a7d30dd3f3?q=80&w=2669&auto=format&fit=crop')",
          }}
        ></div>
        <div className="curtain-content">
          <h2 className="h1" style={{ color: '#fff' }}>Pronto a fare la tua parte?</h2>
          <p
            className="mt-4"
            style={{ color: '#fff', maxWidth: 600, fontSize: '1.2rem', opacity: 0.9, marginInline: 'auto' }}
          >
            Il cambiamento ha bisogno di gambe per camminare. Partecipa anche tu.
          </p>
          <Link to="/partecipa" className="btn btn--white btn--lg mt-6" style={{ color: 'var(--color-primary)' }}>
            Partecipa ora
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ImageCurtain;
